import { useAuthFlow, useResetMetadataCombination } from 'hooks'
import { ReactElement } from 'react'

interface Props {
  children?: ReactElement
}

/**
 * This component purely exists for the purpose of
 * providing a conveninet place to initialize hooks
 * after all login and app initializiation are completed.
 * Please keep in mind here the application providers such as
 * modals, history, translations etc... are not available. If you need
 * those providers the correct component to use is the ContentInitialized,
 * there everything will be available. This component promary use is to initialize
 * hooks that should stop the application from proceeding before they are done
 */
export function AppInitialized(props: Props) {
  useResetMetadataCombination()

  const ping = useAuthFlow()

  // Commenting following JWT login due to deprecation in favor of Ref token
  // const convertedToken = useJWTToken()
  // return <>{convertedToken && props.children}</>

  return <>{ping ? props.children : null}</>
}
